// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { swiperStyle } from "@steiner/App/Components/XngCarousel";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

/**
 * It's a necessary style that we need for all projects
 */
const xSwiperStyle = css`
    width: 100%;
    .swiper-slide {
        // to make all slides has the same height
        height: auto;
        // To fix swiper render issue
        margin-top: 1px;
        margin-bottom: 1px;
        position: relative;
    }

    // hide swiper arrow navigation and use custom arrow navigation
    .swiper-button-prev,
    .swiper-button-next {
        display: none;
    }
`;

const shadowEl = css`
    content: "";
    position: absolute;
    display: block;
    height: calc(100% - 24px);
    width: ${({ shadowWidth }: any) => shadowWidth || "64px"};
    background: linear-gradient(270deg, ${color("common.white", 1)} 0%, ${color("common.white", 0)} 100%);
    top: 0;
    z-index: 2;
`;

export const xSwiperShadow = css`
    ${xScreen("gt", "md")} {
        &.xng-swiper-with-shadow {
            &:has(.swiper-button-next:not(.swiper-button-disabled)) {
                .swiper-horizontal::after {
                    ${shadowEl}
                    right: 0;
                }
            }
            &:has(.swiper-button-prev:not(.swiper-button-disabled)) {
                .swiper-horizontal::before {
                    ${shadowEl}
                    left: 0;
                    background: linear-gradient(
                        90deg,
                        ${color("common.white", 1)} 0%,
                        ${color("common.white", 0)} 100%
                    );
                }
            }
        }
    }
`;

swiperStyle.container = {
    css: css`
        ${xSwiperStyle}

        .xng-pagination-container > .swiper-scrollbar.swiper-scrollbar-horizontal {
            height: 8px;
            width: 100%;
            position: relative;
            top: unset;
            right: unset;
            bottom: unset;
            left: unset;
            transform: initial;
            display: flex;
            align-items: center;
            background: ${color("common.ui2")};
            border-radius: 4px;
            overflow: hidden;
            margin-top: 16px;
            padding: 0 4px;
            & > .swiper-scrollbar-drag {
                background: ${color("common.ui4")};
                border-radius: 4px;
                height: 4px;
                cursor: pointer;

                &:hover,
                &:active {
                    background: ${color("common.ui9")};
                }
            }
        }

        .swiper-horizontal > .xng-pagination-container {
            display: flex !important;
            width: 100%;
            align-items: center;
            padding: 0;
            border-radius: 0;
            background: transparent;
        }

        ${xSwiperShadow}
    `,
};
